import { cn, Spinner } from "@tournated-com/ui";
import type { FC } from "react";

import { env } from "@/env";

import Loader from "./loader";

const isWhiteLabeledDomain = Boolean(env.domainPlatformMap[window.location.host]);

const SplashScreen: FC<{ className?: string }> = ({ className }) => (
  <div
    className={cn(
      "flex min-h-screen w-full items-center justify-center bg-new-background",
      className
    )}
    role="status"
    aria-label="Loading"
  >
    {isWhiteLabeledDomain ? (
      <Spinner size="md" color="neutral" aria-hidden="true" />
    ) : (
      <div aria-hidden="true">
        <Loader />
      </div>
    )}
  </div>
);

export default SplashScreen;
